import React from "react";
import ReactHtmlParser from "react-html-parser";
import { TranslationKeys } from "../../../infrastructure/const";
import TranslationManager from "../../../infrastructure/translation-manager";
import ITranslationsContext from "../../../infrastructure/context/translations/translations-context.interface";

type CheckboxProps = {
  isChecked: boolean;
  onSelectionChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => void;
  id: string;
  labelHtml: string;
  displayValidationMessage: boolean;
  translationsContext: ITranslationsContext;
  validationMessageClass?: string;
  additionalClassName?: string;
};

const MandatoryCheckbox = ({
  isChecked,
  onSelectionChange,
  id,
  labelHtml,
  displayValidationMessage,
  translationsContext,
  validationMessageClass = "validation-advice",
  additionalClassName,
}: CheckboxProps) => {
  return (
    <div
      className={
        additionalClassName
          ? `termsAndConditionsCheckbox ${additionalClassName}`
          : "termsAndConditionsCheckbox"
      }
    >
      <input
        checked={isChecked}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onSelectionChange(e, id)
        }
        type="checkbox"
        name={id}
        id={id}
        className="checkbox css-checkbox prettyCheckable hidden-checkbox"
      />
      <label className="css-label" htmlFor={id}>
        <span className="terms-checkbox"></span>
        <span>{ReactHtmlParser(labelHtml)}</span>
      </label>
      {displayValidationMessage && !isChecked && (
        <div className={validationMessageClass}>
          <span className="icon-arrow-up"></span>
          {new TranslationManager(translationsContext).getTranslation(
            TranslationKeys.REQUIRED
          )}
        </div>
      )}
    </div>
  );
};

export default MandatoryCheckbox;
